<template>
  <div class="distrubitor">
    <el-form inline label-width="110px">
      <el-form-item>
        <span>&emsp;创意组分配：创建</span>
        <el-input style="width: 55px" @blur="onInputBlur('group', 100)" v-model="configForm.group" @input="onFormChange"></el-input>
        <span>个创意组，</span>
      </el-form-item>

      <el-form-item>
        <span>分配规则：1个创意组下</span>
        <el-input style="width: 50px" @blur="onInputBlur('video', 30)" v-model="configForm.video" @input="onFormChange"></el-input>
        <span>个达人视频</span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
/**
 * @description: 头条达人视频智能创意创意分配器
 */
import { useInputForm } from '@/views/create/gdt/template/components/creative/components/creative-distributor/useDistributor.js'

// eslint-disable-next-line
const props = defineProps({ form: Object })
// eslint-disable-next-line
const emit = defineEmits(['update:form'])
const LIMIT = 30
const { configForm, onFormChange, onInputBlur } = useInputForm(emit, props, ['video'], LIMIT)
</script>

<style lang="scss" scoped>
::v-deep .el-form-item {
  height: 20px;
  line-height: 20px;
  margin-bottom: 0;

  .el-form-item__content {
    height: 20px;
    line-height: 20px;
  }

  .el-input {
    width: 66px;
    height: 20px;
    input {
      line-height: 20px;
      height: 20px;
    }
  }
}
</style>
